import { decrypt } from '@/utils'

export const AUTH_COOKIE_KEYS = {
  token: 'TOKEN',
  uid: 'UID',
  stuId: 'STUID',
  userInfo: 'USER_INFO'
} as const

const LEGACY_STORAGE_KEYS = {
  token: 'token',
  uid: 'uid',
  stuId: 'stuId'
} as const

const COOKIE_MAX_AGE = 7 * 24 * 60 * 60

const normalizeValue = (value: string | null) => {
  const text = String(value || '').trim()

  if (['null', 'undefined', '""', "''"].includes(text)) {
    return ''
  }

  return text.replace(/^["']|["']$/g, '')
}

const getCookieDomain = () => String(process.env.REACT_APP_COOKIE_DOMAIN || '').trim()

export const getAuthCookie = (name: string) => {
  if (typeof document === 'undefined') return ''

  const prefix = `${encodeURIComponent(name)}=`
  const cookie = document.cookie
    .split('; ')
    .find((item) => item.startsWith(prefix))

  if (!cookie) return ''

  try {
    return normalizeValue(decodeURIComponent(cookie.slice(prefix.length)))
  } catch {
    return normalizeValue(cookie.slice(prefix.length))
  }
}

export const setAuthCookie = (name: string, value: string | number) => {
  if (typeof document === 'undefined') return

  removeAuthCookie(name)
  const domain = getCookieDomain()
  const secure = window.location.protocol === 'https:' ? '; Secure' : ''
  const domainPart = domain ? `; Domain=${domain}` : ''
  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(String(value))}; Path=/; Max-Age=${COOKIE_MAX_AGE}; SameSite=Lax${secure}${domainPart}`
}

export const removeAuthCookie = (name: string) => {
  if (typeof document === 'undefined') return

  // 同时删除 host-only 和跨子域 Cookie，兼容历史部署方式。
  document.cookie = `${encodeURIComponent(name)}=; Path=/; Max-Age=0; SameSite=Lax`
  const domain = getCookieDomain()
  if (domain) {
    document.cookie = `${encodeURIComponent(name)}=; Path=/; Domain=${domain}; Max-Age=0; SameSite=Lax`
  }
}

const readLegacyValue = (key: string) => {
  if (typeof window === 'undefined') return ''

  const value = window.localStorage.getItem(key)
  if (!value) return ''

  try {
    return normalizeValue(decrypt(value))
  } catch {
    return ''
  }
}

export const loadAuthValue = (
  cookieName: string,
  legacyKey: keyof typeof LEGACY_STORAGE_KEYS
) => {
  const cookieValue = getAuthCookie(cookieName)
  if (cookieValue) return cookieValue

  const legacyValue = readLegacyValue(LEGACY_STORAGE_KEYS[legacyKey])
  if (legacyValue) {
    setAuthCookie(cookieName, legacyValue)
  }
  return legacyValue
}

export const clearAuthSessionStorage = () => {
  Object.values(AUTH_COOKIE_KEYS).forEach(removeAuthCookie)
  removeAuthCookie('i18n')

  if (typeof window !== 'undefined') {
    Object.values(LEGACY_STORAGE_KEYS).forEach((key) => {
      window.localStorage.removeItem(key)
    })
  }
}
